module.exports = "<select class=\"form-control form-inline\" data-ng-model=$ctrl.selectedLanguage> <option value=en>English</option> <option value=de>Deutsch</option> </select> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/language-dropdown/language-dropdown.html
// module id = 51
// module chunks = 0